export const workTimeSelector = (state) => state.worktime.workTime;
export const workTimeLoadingSelector = (state) => state.worktime.loading;
export const columnsSelector = (state) => state.worktime.columns;
export const columnsWidthSelector = (state) => state.worktime.columnsWidth;
export const totalSelector = (state) => state.worktime.total;
